import styled from 'styled-components';
import Creatable from 'react-select/creatable';

import { rem } from 'approot/shared/style';
import { fontSize14 } from 'approot/shared/styles/typography.style';
import {
  standardInputStyles,
  StandardInputProps,
} from 'approot/shared/styles/inputs.style';
import {
  grey1,
  grey3,
  grey4,
  grey5,
  grey8,
  purple1,
  purple5,
  purple8,
} from 'approot/shared/styles/colours.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

// styled(Creatable) collapses react-select's generic Option type to
// `unknown`; cast back to the original generic signature to keep callers
// type-checked against their actual Option type.
export const CreatableStyled = styled(Creatable)<StandardInputProps>`
  border: none;
  .Select__indicators {
    display: none;
  }

  .Select__option {
    color: ${grey8};
    border-bottom: solid 1px ${grey4};
  }

  .Select__option--is-focused {
    background-color: ${grey3};
  }

  .Select__option--is-selected {
    background-color: ${purple1};
    color: ${purple8};
  }

  .Select__value-container {
    //right and bottom padding replaced by margin of items
    padding: ${rem(3)} 0 0 ${rem(3)};
  }

  .Select__multi-value {
    background-color: ${grey1};
    border: 1px solid ${grey5};
    border-radius: ${rem(borderRadius16)};
    display: flex;
    align-items: center;
    height: ${rem(32)};
    margin: 0 ${rem(spacing4)} ${rem(spacing4)} 0;
    padding: 0 ${rem(3)} 0 0;
  }

  .Select__multi-value__label {
    color: ${grey8};
    font-size: ${fontSize14};
    display: flex;
    align-items: center;
    padding: 0 ${rem(10)} 0 ${rem(12)};
  }

  .Select__multi-value__remove {
    color: ${grey8};
    cursor: pointer;
    border: 1px solid ${grey8};
    border-radius: ${rem(24)};
    background-color: ${grey1};
    ${flexCentreAlignCss}
    width: ${rem(20)};
    height: ${rem(20)};
    padding: 0;
    flex-shrink: 0;

    &:hover {
      background-color: ${purple1};
      color: ${grey8};
    }

    svg {
      width: ${rem(14)};
      height: ${rem(14)};
    }
  }

  .Select__control--is-focused {
    outline: none;
    border-color: ${purple5} !important;
    box-shadow: none;
  }

  .Select__control {
    ${standardInputStyles}
    height: auto;
    padding: 0;
  }

  .Select__menu {
    z-index: 10;
  }
` as unknown as typeof Creatable;
